import * as Actions from '../../../Modules/CmsActions'
import type { PostDataType } from '../../../Types/Api/Post'

const initialState = {
  loading: false,
  previewLoading: false,
  saving: false,
  success: false,
  edit: null,
  currentPostType: {
    id: 0,
    display_name: '',
    name: '',
    template_type: '',
    default_slug_type: '',
    has_amp: false,
    fieldGroups: [],
    url_patterns: [],
  },
  list: [],
  conditions: {
    start_date: null,
    end_date: null,
    title: '',
    taxonomies: null,
  },
  selectPostType: 'publish',
  selectFieldGroup: 'コンテンツ', // TODO:要検討
  pagination: {
    current_page: 1,
    per_page: 15,
    total: 0,
  },
  terms: [],
  postFilter: false,
  filter: '',
  defaultRelatedConditions: [],
  customRelatedConditions: [],
  relatedPostList: [],
  relatedConditionLoading: false,
  maxSlug: null,
}

const UIPostReducer = (state = initialState, action) => {
  switch (action.type) {
    case Actions.REQUEST_SAVE_POST:
      return saving(state)

    case Actions.SUCCESS_CREATE_POST:
      return successSave(state)

    case Actions.RESET_SAVE_POST_STATUS:
      return resetSuccess(state)

    case Actions.REQUEST_SHOW_POST_LIST:
    case Actions.REQUEST_SHOW_POST_FORM:
    case Actions.REQUEST_SEARCH_TAXONOMY:
      return updateCurrentPostTypeWithLoaded(state, action.payload.postType)

    case Actions.UNLOAD_CURRENT_POST_TYPE:
      return { ...state, currentPostType: initialState.currentPostType }

    case Actions.REQUEST_CHANGE_CONDITION_POST:
      return updateCondition(state, action.payload.value)

    case Actions.SUCCESS_SHOW_POST_LIST:
      return updateList(state, action.payload)

    case Actions.SUCCESS_SHOW_POST_FORM:
      return updateEditPost(state, action.payload)

    case Actions.FAILURE_SHOW_POST_FORM:
      return loaded(state)

    case Actions.UNLOAD_EDITINT_POST:
      return unloadEditPage(state)

    case Actions.LOGOUT:
      return initialState

    case Actions.SELECT_FIELDGROUP:
      return selectFieldGroup(state, action.payload.values)

    case Actions.SELECT_POST_TYPE:
      return selectPostType(state, action.payload.values)

    case Actions.REQUEST_DELETE_POST:
    case Actions.REQUEST_VIEW_POST:
      return loading(state)

    case Actions.FINISH_DELETE_POST:
    case Actions.FINISH_VIEW_POST:
      return loaded(state)

    case Actions.REQUEST_PREVIEW_POST:
      return previewLoading(state)

    case Actions.FINISH_PREVIEW_POST:
      return previewLoaded(state)

    case Actions.REQUEST_CHANGE_FILTER_POST:
      return updateFilter(state, action.payload.value)

    case Actions.REQUEST_CHANGE_FILTER_STATUS:
      return setFilter(state, action.payload.value)

    case Actions.LOAD_POST_TERM_LIST:
      return updateterms(state, action.payload)

    case Actions.RESET_TERMS_POST:
      return resetTerms(state)

    case Actions.REQUEST_FETCH_DEFAULT_RELATED_POST_CONDITIONS:
    case Actions.REQUEST_FETCH_CUSTOM_RELATED_POST_CONDITIONS:
    case Actions.REQUEST_SAVE_RELATED_POST_CONDITIONS:
      return relatedConditionLoading(state)

    case Actions.FAILURE_FETCH_DEFAULT_RELATED_POST_CONDITIONS:
    case Actions.FAILURE_FETCH_CUSTOM_RELATED_POST_CONDITIONS:
    case Actions.FAILURE_SAVE_RELATED_POST_CONDITIONS:
      return relatedConditionLoaded(state)

    case Actions.FINISH_FETCH_DEFAULT_RELATED_POST_CONDITIONS:
      return updatelRelatedDefaultConditions(state, action.payload)

    case Actions.FINISH_FETCH_CUSTOM_RELATED_POST_CONDITIONS:
      return updatelRelatedCustomConditions(state, action.payload)

    case Actions.FINISH_SAVE_RELATED_POST_CONDITIONS:
      return updatelRelatedDefaultCondition(state, action.payload)

    case Actions.UNLOAD_DEFAULT_RELATED_POST_CONDITIONS:
      return { ...state, defaultRelatedConditions: [] }

    case Actions.UNLOAD_CUSTOM_RELATED_POST_CONDITIONS:
      return { ...state, customRelatedConditions: [] }

    case Actions.REQUEST_SHOW_POST_LIST_IN_SETTING:
      return updateRelatedPostListWithLoaded(state, action.payload)

    case Actions.SUCCESS_SHOW_POST_LIST_IN_SETTING:
      return updateRelatedPostList(state, action.payload)

    case Actions.UNLOAD_POST_LIST_IN_SETTING:
      return { ...state, relatedPostList: [] }

    case Actions.CLEAR_POST_LIST_IN_SETTING:
      return clearRelatedPostList(state, action.payload)

    case Actions.SELECT_MAX_SLUG:
      return getMaxSlug(state, action.payload.value)

    default:
      return state
  }
}

const getMaxSlug = (state, value) => {
  return {
    ...state,
    maxSlug: value,
  }
}

function loading(state) {
  return { ...state, loading: true }
}

function loaded(state) {
  return { ...state, loading: false }
}

const previewLoading = (state) => {
  return { ...state, previewLoading: true }
}

const previewLoaded = (state) => {
  return { ...state, previewLoading: false }
}

const setterms = (payload) => {
  const taxonomies = payload.terms.reduce((prev, term) => {
    prev[term.taxonomy_id] =
      prev[term.taxonomy_id] === undefined
        ? [term]
        : [...prev[term.taxonomy_id], term]
    return prev
  }, {})

  const terms = Object.keys(taxonomies).map((taxonomyId) => {
    const taxonomy = taxonomies[taxonomyId]

    const [parents, children] = taxonomy.reduce(
      (prev, term) => {
        const index = term.parent === null ? 0 : 1
        prev[index].push(term)
        return prev
      },
      [[], []],
    )

    return {
      taxonomy_id: taxonomyId,
      terms: parents.map((parent) => {
        return {
          ...parent,
          children: children.filter((t) => t.parent === parent.id),
        }
      }),
    }
  })

  return terms
}

const resetTerms = (state) => {
  return {
    ...state,
    terms: [],
  }
}

const updateCondition = (state, value) => {
  return {
    ...state,
    conditions: value,
  }
}

const updateFilter = (state, value) => {
  return {
    ...state,
    postFilter: value,
  }
}

const setFilter = (state, value) => {
  return {
    ...state,
    filter: value,
  }
}

function updateCurrentPostTypeWithLoaded(state, postType) {
  const loadingState = loading(state)

  return { ...loadingState, currentPostType: postType }
}

function updateList(state, payload) {
  const terms = setterms(payload)
  return loaded({
    ...state,
    terms,
    list: payload.posts,
    pagination: payload.pagination,
  })
}

function updateEditPost(state, payload) {
  const post = payload.post
  const terms = setterms(payload)
  return loaded({ ...state, terms, edit: post ? post : null })
}

function updateterms(state, payload) {
  const terms = setterms(payload)
  return {
    ...state,
    terms,
  }
}

function unloadEditPage(state) {
  return { ...state, edit: null }
}

function selectFieldGroup(state, values) {
  return { ...state, selectFieldGroup: values }
}

function selectPostType(state, values) {
  return { ...state, selectPostType: values }
}

function saving(state) {
  return { ...state, saving: true }
}

function successSave(state) {
  const succeed = { ...state, success: true, saving: false }
  return loaded(succeed)
}

function resetSuccess(state) {
  return { ...state, success: false, saving: false }
}

function updatelRelatedDefaultConditions(state, payload) {
  const defaultRelatedConditions = payload.defaultRelatedConditions
  return {
    ...state,
    relatedConditionLoading: false,
    defaultRelatedConditions: defaultRelatedConditions,
  }
}

function updatelRelatedCustomConditions(state, payload) {
  const customRelatedConditions = payload.customRelatedConditions
  return {
    ...state,
    relatedConditionLoading: false,
    customRelatedConditions: customRelatedConditions ?? [],
  }
}

function updatelRelatedDefaultCondition(state, payload) {
  const defaultRelatedCondition = payload.defaultRelatedCondition
  const defaultRelatedConditions = state.defaultRelatedConditions.map(
    (condition) => {
      if (condition.id === defaultRelatedCondition.id) {
        return defaultRelatedCondition
      }
      return condition
    },
  )
  return {
    ...state,
    relatedConditionLoading: false,
    defaultRelatedConditions: defaultRelatedConditions,
  }
}

const relatedConditionLoading = (state) => {
  return { ...state, relatedConditionLoading: true }
}

const relatedConditionLoaded = (state) => {
  return { ...state, relatedConditionLoading: false }
}

const updateRelatedPostListWithLoaded = (state, payload) => {
  return {
    ...state,
    relatedPostList: [
      ...filterPostList(state.relatedPostList, payload.postTypeFieldId),
      {
        ...findPostList(state.relatedPostList, payload.postTypeFieldId),
        postTypeFieldId: payload.postTypeFieldId,
        loading: true,
      },
    ],
  }
}

const updateRelatedPostList = (state, payload) => {
  const prevData =
    findPostList(state.relatedPostList, payload.postTypeFieldId)?.list ?? []

  const parseData = payload.posts.reduce((prev: PostDataType[], current) => {
    const dupData =
      prevData.length && prevData.find((el) => el.id == current.id)
    if (!dupData) {
      prev.push(current)
    }
    return prev
  }, [])

  return {
    ...state,
    relatedPostList: [
      ...filterPostList(state.relatedPostList, payload.postTypeFieldId),
      {
        ...findPostList(state.relatedPostList, payload.postTypeFieldId),
        postTypeId: payload.postTypeId,
        list: [...prevData, ...parseData],
        loading: false,
      },
    ],
  }
}

const clearRelatedPostList = (state, payload) => {
  const targetPostList = findPostList(
    state.relatedPostList,
    payload.postTypeFieldId,
  )
  if (!targetPostList) return { ...state }

  return {
    ...state,
    relatedPostList: [
      ...filterPostList(state.relatedPostList, payload.postTypeFieldId),
      {
        ...findPostList(state.relatedPostList, payload.postTypeFieldId),
        list: [],
      },
    ],
  }
}

const filterPostList = (postList, postTypeFieldId) => {
  return postList.filter((post) => {
    return post.postTypeFieldId !== postTypeFieldId
  })
}

const findPostList = (postList, postTypeFieldId) => {
  return postList.find((post) => {
    return post.postTypeFieldId === postTypeFieldId
  })
}

export default UIPostReducer
